import { useEffect, useState } from 'react';
import { captureErrorInApm } from '../../../../lib/apm/utils/captureErrorInApm.util';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import { useNetworkContext } from '../../contexts/network/network.context';
import { useOfflineDataDownloadInformation } from '../useOfflineDataDownloadInformation';
import { useQueryKeysAndFnToCache } from '../useOfflineDataDownloader/hooks/useQueryKeysAndFnToCache/useQueryKeysAndFnToCache';
import { useOfflineDownloadStatusStoreIsHydrated } from '../useOfflineDataDownloader/stores/offlineDownloadStatus/hooks/useOfflineDownloadStatusStoreIsHydrated';
import { useOfflineDataDownloader } from '../useOfflineDataDownloader/useOfflineDataDownloader';
import { QueryKeysAndFnToAutoUpdateGenerator } from './utils/KeysToAutoUpdateGenerator/QueryKeysAndFnToAutoUpdateGenerator';

export const useAutoOfflineDataUpdate = () => {
  const { team } = useApplicationContext();

  const { updatePartialData } = useOfflineDataDownloader();
  const { staticQueryKeysAndFn } = useQueryKeysAndFnToCache();
  const { hasSyncedData, isSyncing } = useOfflineDataDownloadInformation();
  const { isForcingOfflineMode, setIsForcingOfflineMode } = useNetworkContext();
  const offlineDownloadStatusStoreIsHydrated = useOfflineDownloadStatusStoreIsHydrated();

  const [alreadyLoaded, setAlreadyLoaded] = useState(false);

  const updateOfflineDataIfShould = async (teamId: string) => {
    const autoUpdateGenerator = new QueryKeysAndFnToAutoUpdateGenerator({
      teamId,
      queryKeysAndFnOptions: staticQueryKeysAndFn,
    });

    try {
      const optionsToUpdate = await autoUpdateGenerator.generate();

      console.warn('[useAutoOfflineDataUpdate] optionsToUpdate generated:', optionsToUpdate);

      if (!optionsToUpdate.length) {
        return;
      }

      if (isForcingOfflineMode) {
        setIsForcingOfflineMode({ forceOfflineMode: false });
        return;
      }

      await updatePartialData(optionsToUpdate);
    } catch (error: any) {
      captureErrorInApm.offlineError(error);
      console.error('[updateOfflineDataIfShould] error updating offline data:', error);
    }
  };

  useEffect(() => {
    if (
      alreadyLoaded ||
      isSyncing ||
      !team?.id ||
      !hasSyncedData ||
      !offlineDownloadStatusStoreIsHydrated
    ) {
      return;
    }

    setAlreadyLoaded(true);

    updateOfflineDataIfShould(team.id);
  }, [hasSyncedData, team?.id, offlineDownloadStatusStoreIsHydrated]);
};
